import React, { useEffect, useState } from "react";
import { Button } from "rsuite";
import { useTranslation } from "react-i18next";
import ViewImportedCustomers from "./ViewImportedCustomers";
import ViewFailedCustomers from "./ViewFailedCustomers";
import ViewExistingCustomers from "./ViewExistingCustomers";

const CustomerBulkImportAction = ({
  importedData,
  failedData,
  existingData,
  ...props
}: {
  importedData?: any;
  failedData?: any;
  existingData?: any;
}) => {
  const { t } = useTranslation();

  const [openModalByName, setOpenModalByName] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {}, []);

  return (
    <div className="customer-action col-md-8 customer-action">
      <React.Fragment>
        <Button
          onClick={() => setOpenModalByName("view-imported-customers")}
          color="green"
          type="button"
        >
          {t("VIEW")} ({importedData.length}) {t("IMPORTED")} {t("CUSTOMERS")}
        </Button>

        <Button
          onClick={() => setOpenModalByName("view-failed-customers")}
          color="red"
          type="button"
        >
          {t("VIEW")} ({failedData.length}) {t("FAILED")} {t("CUSTOMERS")}
        </Button>

        <Button
          onClick={() => setOpenModalByName("view-existing-customers")}
          color="blue"
          type="button"
        >
          {t("VIEW")} ({existingData.length}) {t("EXISTING")} {t("CUSTOMERS")}
        </Button>
      </React.Fragment>

      {openModalByName === "view-imported-customers" && (
        <ViewImportedCustomers
          openModal={true}
          setOpenModal={setOpenModalByName}
          importedData={importedData}
        />
      )}

      {openModalByName === "view-failed-customers" && (
        <ViewFailedCustomers
          openModal={true}
          setOpenModal={setOpenModalByName}
          failedData={failedData}
        />
      )}

      {openModalByName === "view-existing-customers" && (
        <ViewExistingCustomers
          openModal={true}
          setOpenModal={setOpenModalByName}
          existingData={existingData}
        />
      )}
    </div>
  );
};

export default CustomerBulkImportAction;
